// Authentication Cache Management Utility
// Use this to clear all cached authentication data when switching client IDs

export const clearAllAuthCache = () => {
  console.log('🧹 Clearing all authentication cache...');
  
  try {
    // Clear localStorage auth data
    const authKeys = [
      'adminEmail',
      'adminName', 
      'adminPhoto',
      'isAdminAuthenticated',
      'firebase:authUser:AIzaSyDdxevJHAZS-u1loYOplKTHwtVMx8_bd0U:[DEFAULT]',
      'firebase:host:officialvishwatejaweb.firebaseapp.com',
      'gapi.load_1',
      'google-auth-library',
    ];
    
    authKeys.forEach(key => {
      localStorage.removeItem(key);
      console.log(`✅ Removed localStorage: ${key}`);
    });

    // Clear sessionStorage auth data
    const sessionKeys = [
      'partnerSession',
      'googleAuth',
      'firebase:authUser',
    ];
    
    sessionKeys.forEach(key => {
      sessionStorage.removeItem(key);
      console.log(`✅ Removed sessionStorage: ${key}`);
    });

    // Clear any Google Identity Services cache
    if (typeof window !== 'undefined' && window.google && window.google.accounts) {
      try {
        window.google.accounts.id.disableAutoSelect();
        console.log('✅ Disabled Google auto-select');
      } catch (e) {
        console.log('⚠️ Could not disable Google auto-select:', e.message);
      }
    }

    console.log('🎉 Authentication cache cleared successfully!');
    console.log('💡 Please refresh the page and try logging in again.');
    
    return true;
  } catch (error) {
    console.error('❌ Error clearing auth cache:', error);
    return false;
  }
};

export const clearGoogleAuthCache = () => {
  console.log('🧹 Clearing Google authentication cache...');
  
  try {
    // Remove Google-specific items
    localStorage.removeItem('gapi.load_1');
    localStorage.removeItem('google-auth-library');
    
    // Clear Google Identity Services state
    if (typeof window !== 'undefined' && window.google && window.google.accounts) {
      window.google.accounts.id.disableAutoSelect();
    }
    
    console.log('✅ Google auth cache cleared!');
    return true;
  } catch (error) {
    console.error('❌ Error clearing Google auth cache:', error);
    return false;
  }
};

export const forceRefreshAuth = () => {
  console.log('🔄 Forcing authentication refresh...');
  
  // Clear caches
  clearAllAuthCache();
  
  // Force page reload after a short delay
  setTimeout(() => {
    window.location.reload();
  }, 1000);
};

// Debug function to show current auth cache state
export const debugAuthCache = () => {
  console.log('🔍 Current Authentication Cache State:');
  
  // Check localStorage
  console.log('📦 LocalStorage:');
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.includes('auth') || key.includes('admin') || key.includes('firebase') || key.includes('google')) {
      console.log(`  ${key}: ${localStorage.getItem(key)?.substring(0, 50)}...`);
    }
  }
  
  // Check sessionStorage  
  console.log('🗂️ SessionStorage:');
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key.includes('auth') || key.includes('admin') || key.includes('firebase') || key.includes('google')) {
      console.log(`  ${key}: ${sessionStorage.getItem(key)?.substring(0, 50)}...`);
    }
  }
  
  // Check Google services
  console.log('🔗 Google Services:');
  console.log(`  Google Identity Services Available: ${window.google && window.google.accounts ? 'Yes' : 'No'}`);
  console.log(`  GAPI Available: ${window.gapi ? 'Yes' : 'No'}`);
};